import script from "./ToastNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToastNotification.vue?vue&type=script&setup=true&lang=ts"

import "./ToastNotification.vue?vue&type=style&index=0&id=f523fa6e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f523fa6e"]])

export default __exports__